export default {
  fbLongLivedAccessToken: null,
  igBusinessAccountId: null,
  igUserPages: [],
  listTimezone: []
}
